import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const BrokenHouseIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="34"
      height="30"
      viewBox="0 0 34 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6936 0.242428C17.4925 0.085321 17.2448 0 16.9898 0C16.7348 0 16.4871 0.085321 16.286 0.242428L0 12.9674L1.40873 14.7526L3.4 13.1968V27.255C3.4012 27.857 3.64039 28.434 4.06521 28.8597C4.49004 29.2854 5.06588 29.5251 5.66667 29.5263H28.3333C28.9341 29.5251 29.51 29.2854 29.9348 28.8597C30.3596 28.434 30.5988 27.857 30.6 27.255V13.207L32.5913 14.7629L34 12.9776L17.6936 0.242428ZM5.66667 11.4263L15.8667 3.46313V11.8261L19.7857 15.7531L12.1539 21.2156L15.1663 27.255H5.66667V11.4263ZM28.3333 27.255H17.7004L15.0461 21.9368L23.2809 16.0427L18.1333 10.8869V3.4654L28.3333 11.4377V27.255Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default BrokenHouseIcon;

BrokenHouseIcon.propTypes = customIconsPropTypes;
